import apiClient from './client';

// ===== Environment Settings API (Administrator Only) =====

export interface EnvSetting {
  value: string;
  is_encrypted: boolean;
  updated_at: string | null;
}

export interface EnvSettingsResponse {
  status: string;
  env_keys: string[];
  settings: Record<number, Record<string, EnvSetting>>;
}

// 환경변수 설정 조회 (Administrator 전용)
export const getEnvSettings = async (
  adminId?: number
): Promise<EnvSettingsResponse> => {
  const params = new URLSearchParams();
  if (adminId) params.append('admin_id', adminId.toString());

  const response = await apiClient.get(`/api/admin/settings/env?${params.toString()}`);
  return response.data;
};

// 환경변수 설정 업데이트 (Administrator 전용)
export const updateEnvSettings = async (
  targetAdminId: number,
  settings: Record<string, string>
): Promise<{
  status: string;
  target_admin_id: number;
  updated: string[];
}> => {
  const response = await apiClient.put(`/api/admin/settings/env/${targetAdminId}`, settings);
  return response.data;
};

// 환경변수 설정 삭제 (Administrator 전용)
export const deleteEnvSetting = async (
  targetAdminId: number,
  key: string
): Promise<{
  status: string;
  target_admin_id: number;
  key: string;
  message: string;
}> => {
  const response = await apiClient.delete(`/api/admin/settings/env/${targetAdminId}/${key}`);
  return response.data;
};

// .env 파일에서 환경변수 마이그레이션 (Administrator 전용)
export const migrateEnvSettings = async (
  envFile: string,
  targetAdminId: number
): Promise<{
  status: string;
  env_file: string;
  target_admin_id: number;
  migrated: string[];
}> => {
  const response = await apiClient.post('/api/admin/settings/env/migrate', {
    env_file: envFile,
    target_admin_id: targetAdminId
  });
  return response.data;
};

// 관리자 목록 조회 (Administrator 전용)
export const getAdminList = async (): Promise<{
  status: string;
  admins: Array<{
    admin_id: number;
    username: string;
    display_name: string;
    role: string;
    is_active: boolean;
    last_login: string | null;
    created_at: string | null;
  }>;
}> => {
  const response = await apiClient.get('/api/auth/admins');
  return response.data;
};
